import styled from "styled-components";
import Layout_user from "../../../Component/UI/Layout_user";
import TopBar from "../../../Component/UI/TopBar";
import { Icon, RowView } from "../../../Component/style/common_style";
import { useState } from "react";
import Step1 from "./Component/Step1";
import { data } from "react-router-dom";
import Step2 from "./Component/Step2";
import Step3 from "./Component/Step3";
import CompleteModal from "./Modal/CompleteModal";
import axios from "axios";
import url from "../../../Component/server";

const AdminSignUp = () => {
  const [step, setStep] = useState(1);
  const nextStep = () => {
    setStep(step + 1);
  };
  const backStep = () => {
    setStep(step - 1);
  };
  const handleStep = (data: number) => {
    setStep(data);
  };

  // Step1
  // 대표자명
  const [name, setName] = useState("");
  const handleName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setName(input);
  };

  // 연락처
  const [phoneNum, setPhoneNum] = useState("");
  const handlePhoneNum = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setPhoneNum(input);
  };

  // 이메일
  const [email, setEmail] = useState("");
  const [domain, setDomain] = useState("");
  const [selectDomain, setSelectDomain] = useState("");

  const handleEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setEmail(input);
  };
  const handleDomain = (e: React.ChangeEvent<HTMLInputElement> | string) => {
    typeof e === "string" ? setDomain(e) : setDomain(e.target.value);
  };
  const handleSelectDomain = (data: string) => {
    setSelectDomain(data);
  };

  // Step2
  // 사업자명
  const [BUSName, setBUSName] = useState("");
  const handleBUSName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setBUSName(input);
  };

  // 사업자 주소
  const [BUSPostCode, setBUSPostCode] = useState("");
  const [BUSFirAddr, setBUSFirAddr] = useState("");
  const [BUSSecAddr, setBUSSecAddr] = useState("");

  const handlePostCode = (data: string) => {
    setBUSPostCode(data);
  };
  const handleFirAddr = (data: string) => {
    setBUSFirAddr(data);
  };
  const handleSecAddr = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setBUSSecAddr(input);
  };

  // 사업자등록증
  const [BUSImage, setBUSImage] = useState<string[]>([]);
  const uploadBUSImage = (data: string) => {
    setBUSImage((prev) => [...prev, data]);
  };
  const delBUSImage = (data: string, index: number) => {
    setBUSImage((prev) => prev.filter((_, i) => i !== index));
  };

  // Step3
  // 스토어명
  const [storeName, setStoreName] = useState("");
  const handleStoreName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setStoreName(input);
  };
  const [storeNameCheck, setStoreNameCheck] = useState(false);

  // 계좌번호
  const [accountNum, setAccountNum] = useState("");
  const handleAccountNum = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setAccountNum(input);
  };

  // 은행명
  const [bank, setBank] = useState("");
  const handleBank = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setBank(input);
  };

  // 예금주명
  const [accountHolder, setAccountHolder] = useState("");
  const handleAccountHolder = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setAccountHolder(input);
  };
  // 카카오톡 채널 URL
  const [kakaoURL, setKakaoURL] = useState("");
  const handleKakaoURL = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setKakaoURL(input);
  };
  // 약관
  const [check1, setCheck1] = useState(false);
  const [check2, setCheck2] = useState(false);

  const handleCheck1 = () => {
    setCheck1(!check1);
  };
  const handleCheck2 = () => {
    setCheck2(!check2);
  };

  // 완료 모달
  const [visible, setVisible] = useState(false);
  const handleModal = () => {
    setVisible(!visible);
  };

  // 입점 신청
  const create_store = async () => {
    // 필수 값 확인
    if (
      !storeName ||
      !name ||
      !phoneNum ||
      !email ||
      !BUSName ||
      !BUSPostCode ||
      !BUSFirAddr ||
      !BUSSecAddr ||
      !bank ||
      !accountNum ||
      !accountHolder ||
      // !kakaoURL ||
      !check1 ||
      !check2 ||
      BUSImage.length === 0
    ) {
      alert("모든 필수 정보를 입력해주세요.");
      return;
    } else if (!storeNameCheck) {
      alert("스토어명 중복확인을 해주세요.");
      return;
    }

    // API 호출
    axios
      .post(
        url.Communication_url.create_store,
        {
          store_name: storeName,
          rep_name: name,
          store_phone: phoneNum,
          store_email: email + "@" + domain,
          com_name: BUSName,
          addr_num: BUSPostCode,
          addr_basic: BUSFirAddr,
          addr_detail: BUSSecAddr,
          bank_name: bank,
          bank_num: accountNum,
          depositor: accountHolder,
          profile_img: "",
          // kakao_channel: kakaoURL,
          terms_agree: "y",
          privacy_agree: "y",
          license: BUSImage[0],
        },
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      )
      .then((res) => {
        if (res.data === "성공") {
          handleModal();
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response.status === 400) alert(error.response.data.message);
      });
  };

  return (
    <Layout_user background="white">
      <TopBar title="입점 신청" color="white" />
      <div style={{ padding: 15 }}>
        <RowView style={{ marginTop: 24 }}>
          <StepBox
            $select={step === 1}
            onClick={() => {
              handleStep(1);
            }}
          >
            1. 기본 정보
          </StepBox>
          <Icon src={require("../../../Image/ic_3dot_gray.png")} />
          <StepBox
            $select={step === 2}
            onClick={() => {
              handleStep(2);
            }}
          >
            2. 사업자 정보
          </StepBox>
          <Icon src={require("../../../Image/ic_3dot_gray.png")} />
          <StepBox
            $select={step === 3}
            onClick={() => {
              handleStep(3);
            }}
          >
            3. 판매 채널 정보
          </StepBox>
        </RowView>
        {step === 1 ? (
          <Step1
            name={name}
            handleName={handleName}
            phoneNum={phoneNum}
            handlePhoneNum={handlePhoneNum}
            email={email}
            handleEmail={handleEmail}
            domain={domain}
            handleDomain={handleDomain}
            selectDomain={selectDomain}
            handleSelectDomain={handleSelectDomain}
          />
        ) : step === 2 ? (
          <Step2
            BUSName={BUSName}
            handleBUSName={handleBUSName}
            BUSPostCode={BUSPostCode}
            BUSFirAddr={BUSFirAddr}
            BUSSecAddr={BUSSecAddr}
            setBUSPostCode={setBUSPostCode}
            setBUSFirAddr={setBUSFirAddr}
            handleSecAddr={handleSecAddr}
            BUSImage={BUSImage}
            uploadBUSImage={uploadBUSImage}
            delBUSImage={delBUSImage}
          />
        ) : (
          <Step3
            // 스토어명
            storeName={storeName}
            handleStoreName={handleStoreName}
            accountNum={accountNum}
            handleAccountNum={handleAccountNum}
            bank={bank}
            handleBank={handleBank}
            accountHolder={accountHolder}
            handleAccountHolder={handleAccountHolder}
            kakaoURL={kakaoURL}
            handleKakaoURL={handleKakaoURL}
            check1={check1}
            check2={check2}
            handleCheck1={handleCheck1}
            handleCheck2={handleCheck2}
            setStoreNameCheck={setStoreNameCheck}
          />
        )}
        <RowView style={{ gap: 16 }}>
          <BackBtn
            style={{ display: step === 1 ? "none" : "flex" }}
            onClick={backStep}
          >
            이전
          </BackBtn>
          <NextBtn
            style={{ display: step === 3 ? "none" : "flex" }}
            onClick={nextStep}
          >
            다음
          </NextBtn>
          <NextBtn
            style={{ display: step === 3 ? "flex" : "none" }}
            onClick={create_store}
          >
            신청하기
          </NextBtn>
        </RowView>
      </div>
      <CompleteModal visible={visible} handleModal={handleModal} />
    </Layout_user>
  );
};

export default AdminSignUp;

const StepBox = styled.div<{ $select: boolean }>`
  border: 1px solid;
  border-radius: 8px;
  border-color: ${(props) => (props.$select ? "black" : "#E8E8E8")};
  color: ${(props) => (props.$select ? "black" : "#8E8E8E")};
  width: 136px;
  height: 42px;
  align-items: center;
  justify-content: center;
  text-align: center;
  display: flex;
  font-family: var(--font-Pretendard-Medium);
  cursor: pointer;
`;

const Btn = styled.div`
  display: flex;
  margin-top: 40px;
  width: 100%;
  height: 48px;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: var(--font-Pretendard-SemiBold);
`;

const NextBtn = styled(Btn)`
  background: linear-gradient(135deg, #7955f0, #3209b9);
  color: white;
`;

const BackBtn = styled(Btn)`
  background: #f8f8f8;
  color: #8e8e8e;
`;
